import { ApplicationRef, Injectable, Injector, WritableSignal, effect, inject, signal } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { FikoYTEnvIstemci } from './Environment/environment';
import { CihazKimlikService } from './fikoyt.cihaz-kimlik.service';
import { FikoYTService } from './fikoyt.service';


export class SocketFikoYT extends Socket {

  bagli: WritableSignal<boolean> = signal(false);

  nameSpaces = new Map();

  constructor(private FikoYT: FikoYTService,) {

    super({
      url: FikoYTEnvIstemci.adres.url + ':' + FikoYTEnvIstemci.adres.fapiPort + '/', options: {
        ...FikoYTEnvIstemci.adres.options,
        extraHeaders: {
          "uygulama": FikoYTEnvIstemci.uygulamaAdi,
          "cihaz_kimlik": FikoYT.cihaz.kimlik,
          //@ts-ignore
          "kullanici_kimlik": FikoYT?.kimlik?.aktifKullaniciJson()?._id ?? null,
          "cihaz_tipi": FikoYT.cihaz.bilgiler.deviceType,
          // @ts-ignore
          "cihaz_bilgi": FikoYT.cihaz.bilgiler,
        }
      }
    }, inject(ApplicationRef));

    this.fromEvent('connect').subscribe(async () => {
      this.bagli.set(true);
      try {
        await this.gonder("FikoYT.sistem.io.cihaz.baglandi");
      } catch (error) {

      }

    });
    this.fromEvent('reconnect').subscribe(async () => {
      this.bagli.set(true);
      try {
        await this.gonder("FikoYT.sistem.io.cihaz.baglandi");
      } catch (error) {

      }

    });
    this.fromEvent('disconnect').subscribe(() => {
      this.bagli.set(false);
    });


  }

  baglan() {
    super.connect();
  }


  kop() {
    if (this.bagli())
      super.disconnect();
    // this.removeAllListeners();
  }

  override of(namespace: string) {
    if (this.nameSpaces.has(namespace))
      return this.nameSpaces.get(namespace);

    const socketInstance = new Socket({
      url: FikoYTEnvIstemci.adres.url + ':' + FikoYTEnvIstemci.adres.fapiPort + '/' + namespace, options: {
        ...FikoYTEnvIstemci.adres.options ?? {}, extraHeaders: {
          "uygulama": FikoYTEnvIstemci.uygulamaAdi,
          "cihaz_kimlik": this.FikoYT.cihaz.kimlik,
          //@ts-ignore
          "kullanici_kimlik": this.FikoYT.kimlik.aktifKullaniciJson()?._id ?? null,
          "cihaz_tipi": this.FikoYT.cihaz.bilgiler.deviceType,
          //@ts-ignore
          "cihaz_bilgi": this.FikoYT.cihaz.bilgiler,
        }
      }
    }, inject(ApplicationRef))
    this.nameSpaces.set(namespace, socketInstance);
    return this.nameSpaces.get(namespace);
  }


  // eventUyeGirisYapti(bilgilerKullanici: any) {
  //   this.emit("FikoYT.sistem.uye.girisYapti", bilgilerKullanici);
  // }

  // eventUyeCikisYapti(bilgilerKullanici: any) {
  //   this.emit("FikoYT.sistem.uye.cikisYapti", bilgilerKullanici);
  // }

  // async serverFonksiyon(komut: string, parametreler: Array<any> | any) {
  //   return new Promise(resolve => {
  //     if (Array.isArray(parametreler) == true) {
  //       this.emit(komut, ...parametreler, (snc: any) => {
  //         resolve(snc);
  //       });
  //     } else {
  //       this.emit(komut, parametreler, (snc: any) => {
  //         resolve(snc);
  //       });
  //     }
  //   });
  // }

  // async serverPcKomutCalistir(komut: string | string[]): Promise<any> {
  //   return new Promise(resolve => {
  //     // this.emit(FikoWsYollar.FikoYT.sistem.serverPc.komutCalistir, komut, (snc: any) => {
  //     //   resolve(snc);
  //     // });

  //   });
  // }
  async serverFonksiyon(komut: string, parametreler: Array<any> | any) {
    return new Promise(resolve => {
      if (Array.isArray(parametreler) == true) {
        this.emit(komut, ...parametreler, (snc: any) => {
          resolve(snc);
        });
      } else {
        this.emit(komut, parametreler, (snc: any) => {
          resolve(snc);
        });
      }
    });
  }


  async gonder<T>(_eventName: string, ..._args: any[]): Promise<T | null> {
    // console.log(this.FikoYT.cihaz.bilgiler)
    try {
      let FikoYTData = {
        "FikoYT": {
          "kullanici_kimlik": this.FikoYT.kimlik.aktifKullaniciJson()?._id ?? null,
          "cihaz_kimlik": this.FikoYT.cihaz.kimlik,
          "cihaz_tipi": this.FikoYT.cihaz.bilgiler.deviceType,
          "uygulama": FikoYTEnvIstemci.uygulamaIsmi,
          //@ts-ignore
          "cihaz_bilgi": this.FikoYT.cihaz.bilgiler,
          // ...(FikoYTCoreService.serviceSettings.socketDataMiddleWare ?? {}),
        }
      };

      let data = [
        ..._args ?? null,
        FikoYTData,
      ];
      return await super.emitWithAck(_eventName, ...data);
    } catch (error) {
      return null;
    }
  }
}
